import { useState, useCallback, useEffect } from 'react';
import { UserAPI } from 'api/user';
import { LANGUAGE_OVERRIDEN, LANGUAGE_SELECT } from 'constant/constant';
import { fetchTranslation } from 'utils/translation-loader';
import { useUser, useUserSafe } from './use-user';
export const loadTranslationFile = async (locale, fallback = true)=>{
    try {
        const translations = await fetchTranslation(locale);
        if (fallback && locale !== 'en') {
            const english = await fetchTranslation('en');
            return {
                ...english,
                ...translations
            };
        }
        return translations;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        return await fetchTranslation('en');
    }
};
// Supported languages list
export const SUPPORTED_LANGUAGES = [
    'en',
    'es',
    'it',
    'fr',
    'nl',
    'de',
    'sv',
    'fi',
    'ja',
    'da',
    'no',
    'zh',
    'zh-HK',
    'pt-BR',
    'pt-PT',
    'es-419'
];
export function getBrowserLocale() {
    if (typeof navigator === 'undefined') {
        return null;
    }
    const browserLang = navigator.language.toLowerCase();
    const exactMatch = SUPPORTED_LANGUAGES.find((lang)=>lang.toLowerCase() === browserLang);
    if (exactMatch) {
        return exactMatch;
    }
    const base = browserLang.split('-')[0];
    const baseMatch = SUPPORTED_LANGUAGES.find((lang)=>lang.toLowerCase() === base);
    if (baseMatch) {
        return baseMatch;
    }
    return null;
}
/**
 * @deprecated
 */ export function getLocale() {
    const locale = navigator.language.split('-')[0];
    if (SUPPORTED_LANGUAGES.includes(locale) && locale !== 'en' && localStorage.getItem(LANGUAGE_OVERRIDEN) !== 'true') {
        return locale;
    }
    const stored = localStorage.getItem(LANGUAGE_SELECT);
    if (stored) {
        try {
            Intl.getCanonicalLocales(stored);
            return stored;
        } catch (unused) {
            localStorage.removeItem(LANGUAGE_SELECT);
        }
    }
    return 'en';
}
/**
 * @deprecated
 */ export const useLoadTranslationV1 = ()=>{
    const [state, setState] = useState(getLocale());
    const listen = ()=>{
        const stored = localStorage.getItem(LANGUAGE_SELECT);
        if (stored) {
            try {
                Intl.getCanonicalLocales(stored);
                setState(stored);
                return;
            } catch (unused) {
                localStorage.removeItem(LANGUAGE_SELECT);
            }
        }
        setState('en');
    };
    window.addEventListener(LANGUAGE_SELECT, listen);
    return {
        locale: state,
        message: loadTranslationFile(state)
    };
};
/**
 * @deprecated
 */ export const useLocaleV1 = ()=>{
    const [state, setState] = useState(getLocale());
    const change = useCallback((newLocale)=>{
        setState(newLocale);
        localStorage.setItem(LANGUAGE_SELECT, newLocale);
        localStorage.setItem(LANGUAGE_OVERRIDEN, 'true');
        const event = new StorageEvent(LANGUAGE_SELECT, {
            key: LANGUAGE_SELECT
        });
        window.dispatchEvent(event);
    }, []);
    return {
        locale: state,
        setLocale: change
    };
};
export const useLoadTranslation = ()=>{
    var _user_emailLanguagePreference;
    const { user } = useUser();
    const [state, setState] = useState(user === null || user === void 0 ? void 0 : (_user_emailLanguagePreference = user.emailLanguagePreference) === null || _user_emailLanguagePreference === void 0 ? void 0 : _user_emailLanguagePreference.toLowerCase());
    const listen = useCallback(()=>{
        var _user_emailLanguagePreference;
        setState((user === null || user === void 0 ? void 0 : (_user_emailLanguagePreference = user.emailLanguagePreference) === null || _user_emailLanguagePreference === void 0 ? void 0 : _user_emailLanguagePreference.toLowerCase()) || 'en');
    }, [
        user === null || user === void 0 ? void 0 : user.emailLanguagePreference
    ]);
    useEffect(()=>{
        listen();
    }, [
        listen
    ]);
    return {
        locale: state,
        message: loadTranslationFile(state || 'en')
    };
};
export const useLocale = ()=>{
    var _ref, _ref1, _ref2;
    var _userSafe_user_emailLanguagePreference, _userSafe_user, _userSafe_user1, _userSafe_user_emailLanguagePreference1, _userSafe_user2;
    const userSafe = useUserSafe();
    const [state, setState] = useState(userSafe === null || userSafe === void 0 ? void 0 : (_userSafe_user = userSafe.user) === null || _userSafe_user === void 0 ? void 0 : (_userSafe_user_emailLanguagePreference = _userSafe_user.emailLanguagePreference) === null || _userSafe_user_emailLanguagePreference === void 0 ? void 0 : _userSafe_user_emailLanguagePreference.toLowerCase());
    const change = useCallback((newLocale)=>{
        setState(newLocale);
        localStorage.setItem(LANGUAGE_SELECT, newLocale);
        UserAPI.updateCurrentUser({
            emailLanguagePreference: newLocale
        }).then(()=>{
            window.location.reload();
        });
    }, []);
    useEffect(()=>{
        var _userSafe_user_emailLanguagePreference, _userSafe_user;
        const pref = userSafe === null || userSafe === void 0 ? void 0 : (_userSafe_user = userSafe.user) === null || _userSafe_user === void 0 ? void 0 : (_userSafe_user_emailLanguagePreference = _userSafe_user.emailLanguagePreference) === null || _userSafe_user_emailLanguagePreference === void 0 ? void 0 : _userSafe_user_emailLanguagePreference.toLowerCase();
        if (pref) {
            setState(pref);
            localStorage.setItem(LANGUAGE_SELECT, pref);
        }
    }, [
        userSafe === null || userSafe === void 0 ? void 0 : (_userSafe_user1 = userSafe.user) === null || _userSafe_user1 === void 0 ? void 0 : _userSafe_user1.emailLanguagePreference
    ]);
    return {
        locale: (_ref = (_ref1 = (_ref2 = userSafe === null || userSafe === void 0 ? void 0 : (_userSafe_user2 = userSafe.user) === null || _userSafe_user2 === void 0 ? void 0 : (_userSafe_user_emailLanguagePreference1 = _userSafe_user2.emailLanguagePreference) === null || _userSafe_user_emailLanguagePreference1 === void 0 ? void 0 : _userSafe_user_emailLanguagePreference1.toLowerCase()) !== null && _ref2 !== void 0 ? _ref2 : state) !== null && _ref1 !== void 0 ? _ref1 : getBrowserLocale()) !== null && _ref !== void 0 ? _ref : 'en',
        setLocale: change
    };
};
